import React from "react";
import { Paper, Typography, Box, Chip, alpha, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Info as InfoIcon } from "@mui/icons-material";
import { MAX_VIDEOS_PER_REPORT } from "../hooks/useVideoSelection";

export const InstructionBanner: React.FC = () => {
  const theme = useTheme();

  return (
    <Grid size={{ xs: 12 }}>
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          borderRadius: 2,
          backgroundColor: alpha(theme.palette.info.main, 0.08),
          border: "1px solid",
          borderColor: alpha(theme.palette.info.main, 0.2),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <InfoIcon
          sx={{
            color: theme.palette.info.main,
            fontSize: 28,
            flexShrink: 0,
          }}
        />
        <Typography
          variant="body1"
          sx={{
            color: "text.primary",
            fontSize: { xs: "0.875rem", sm: "1rem" },
            lineHeight: 1.6,
            textAlign: "center",
          }}
        >
          Select up to{" "}
          <Box
            component="span"
            sx={{
              fontWeight: 700,
              color: theme.palette.primary.main,
            }}
          >
            {MAX_VIDEOS_PER_REPORT} videos
          </Box>{" "}
          of the{" "}
          <Box
            component="span"
            sx={{
              fontWeight: 700,
              color: theme.palette.warning.dark,
              textTransform: "uppercase",
            }}
          >
            same incident
          </Box>{" "}
          that are marked as{" "}
          <Chip
            label="READY"
            size="small"
            sx={{
              fontWeight: 700,
              fontSize: "0.75rem",
              height: 22,
              backgroundColor: alpha(theme.palette.success.main, 0.15),
              color: theme.palette.success.dark,
              border: "1px solid",
              borderColor: alpha(theme.palette.success.main, 0.3),
            }}
          />
          . Videos not ready will be disabled.
        </Typography>
      </Paper>
    </Grid>
  );
};
